import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import UIImage from 'UIComponents/image/UIImage'; // @ts-expect-error svg import

import HERO_BG from 'bender-url!pricing-pages-ui/img/ebx633/hero-bg.svg';
import SplashPageHeader from '../../splash-page/SplashPageHeader';
const PageHeader = styled.header.withConfig({
  displayName: "SuiteStarterHeroBanner__PageHeader",
  componentId: "sc-1qdfrnr-0"
})(["position:relative;width:100%;height:136px;display:flex;flex-direction:column;justify-content:center;align-items:center;z-index:-1;"]);
const HeroContainer = styled.div.withConfig({
  displayName: "SuiteStarterHeroBanner__HeroContainer",
  componentId: "sc-1qdfrnr-1"
})(["top:30px;position:absolute;"]);
const HeroBackground = styled(UIImage).withConfig({
  displayName: "SuiteStarterHeroBanner__HeroBackground",
  componentId: "sc-1qdfrnr-2"
})(["position:absolute;width:100vw;top:0;"]);

const SuiteStarterHeroBanner = () => {
  return /*#__PURE__*/_jsxs(PageHeader, {
    children: [/*#__PURE__*/_jsx(HeroBackground, {
      src: HERO_BG
    }), /*#__PURE__*/_jsx(HeroContainer, {
      children: /*#__PURE__*/_jsx(SplashPageHeader, {
        titleKey: "pricingPage.pages.suiteStarter.title",
        subtitleKey: "pricingPage.pages.suiteStarter.subtitle"
      })
    })]
  });
};

export default SuiteStarterHeroBanner;